import React, { useRef, useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Box,
  FormControlLabel,
  Checkbox,
  Typography,
  Grid,
} from "@mui/material";
import { styled } from "@mui/system";
import { CardHeader } from "@mui/material";

const ScrollableEmail = ({
  listData,
  emailData,
  setListData,
  email,
  dataPolicy,
}) => {
  const cardRef = useRef(null);
  const [isChecked, setIsChecked] = useState(false);
  const [selectedIndexes, setSelectedIndexes] = useState([]); // เก็บ index ของ Box ที่ถูกเลือกเป็น array
  const [inputErrors, setInputErrors] = useState([]);
  // const [listData, setListData] = useState([]); // เก็บข้อมูลที่ถูกเลือก

  useEffect(() => {
    // console.log(listData)
    const selectedIndexList = listData.map((item) => item.index); // ดึง index จาก listData
    setSelectedIndexes(selectedIndexList);

    // console.log("cardRef.current:", cardRef.current);
  }, []); // เรียกครั้งเดียวหลัง

  useEffect(() => {
    const updatedList = listData.map((item) => ({
      index: item.index,
      policyNo: item.policyNo,
      oldEmail: item.email,
      email: email,
    }));

    setListData(updatedList);
  }, [email]);

  // useEffect(() => {
  //   console.log("Updated listData:", listData);
  // }, [listData]);

  const CustomCheckbox = styled(Checkbox)({
    color: "rgba(255, 94, 67, 0.5)",
    "&.Mui-checked": {
      color: "#FF5E43",
    },
    marginRight: "15px",
  });

  const handleCheckAll = () => {
    if (isChecked) {
      removeAllItems(); // ลบข้อมูลทั้งหมด
    } else {
      const allIndexes = emailData.map((_, index) => index); // สร้าง array ของทุก index
      setSelectedIndexes(allIndexes);

      const updatedList = emailData.map((item, index) => ({
        index: index,
        policyNo: item.policy_no, // ใช้ข้อมูลจาก emailData แทน listData
        oldEmail: item.email,
        email: email, // ใช้ค่า email ปัจจุบัน
      }));

      setListData(updatedList); // อัปเดต listData ด้วยข้อมูลใหม่ทั้งหมด
    }
    setIsChecked(!isChecked); // เปลี่ยนสถานะ CheckAll
  };

  const handleBoxClick = (index, policyNoVal, emailVal) => {
    setSelectedIndexes((prevIndexes) => {
      if (prevIndexes.includes(index)) {
        // ถ้าถูกเลือกแล้ว ให้ลบออกจาก array ทั้งใน selectedIndexes และ listData
        // console.log("old list : ",listData)
        // console.log("policy : ",policyNoVal.trim())
        setListData((prevList) =>
          prevList.filter((item) => item.policyNo !== policyNoVal.trim())
        );

        // ลบ index ออกจาก selectedIndexes
        return prevIndexes.filter((i) => i !== index);
      } else {
        // ถ้ายังไม่ถูกเลือก ให้เพิ่มเข้าไปใน selectedIndexes
        const updatedList = {
          index: index,
          policyNo: policyNoVal.trim(),
          oldEmail: emailVal,
          email: email,
        };

        // อัปเดต listData โดยตรวจสอบว่า policyNoVal ยังไม่มีอยู่ใน listData ก่อนเพิ่ม
        setListData((prevList) => {
          const alreadyExists = prevList.some(
            (item) => item.policyNo === policyNoVal
          );

          // ถ้าไม่มีใน listData ถึงจะเพิ่ม updatedList เข้าไป
          if (!alreadyExists) {
            return [...prevList, updatedList];
          }
          return prevList;
        });

        // เพิ่ม index เข้าไปใน selectedIndexes
        return [...prevIndexes, index];
      }
    });
  };

  const addItem = (newItem) => {
    setListData((prevListData) => [...prevListData, newItem]);
  };

  // const removeItemByPolicyNo = (policyNo) => {
  //   console.log(prevListData)
  //   console.log(policyNo)
  //   setListData((prevList) =>
  //     prevList.filter((item) => item.policyNo !== policyNoVal)
  //   );

  //   setListData((prevListData) => prevListData.filter(item => item.policyNo !== policyNo));
  // };

  const removeAllItems = () => {
    setListData([]); // ตั้งค่า listData ให้เป็น array ว่าง
    setSelectedIndexes([]); // เคลียร์ selectedIndexes
  };

  return (
    <Card ref={cardRef} sx={{ maxHeight: "490px", overflowY: "auto" }}>
      <CardContent
        sx={{
          maxHeight: "490px",
          overflowY: "auto",
          border: "1px solid rgba(255, 94, 67, 0.3)", // สีของขอบ #FF5E43 ที่โปร่งใส 30%
          borderRadius: "12px", // ความโค้งของขอบ
          borderWidth: "2px",
          display: "flex",
          flexDirection: "column",
          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Box>
          <FormControlLabel
            control={
              <CustomCheckbox onClick={handleCheckAll} checked={isChecked} />
            }
            label={
              <Typography style={{ fontSize: "20px" }}>ทุกกรมธรรม์</Typography>
            }
          />
        </Box>

        <Typography
          variant="body2"
          sx={{ color: "red", marginTop: "5px", marginLeft: "5px" }} // ข้อความสีแดงพร้อม margin ด้านบน
        >
          *กรุณาเลือกกรมธรรม์
        </Typography>

        {emailData.map((_, index) => {
          const policy = dataPolicy[index]; // ดึงข้อมูล baseName ตาม index

          return (
            <Box
              key={index}
              onClick={() => handleBoxClick(index, _.policy_no, _.email)}
              sx={{
                marginBottom: "15px",
                padding: "10px",
                transition: "background-color 0.3s ease, border 0.3s ease",
                cursor: "pointer",
                alignItems: "center",
                justifyContent: "space-between",
                border: selectedIndexes.includes(index)
                  ? "2px solid #FF5E43"
                  : "1px solid #e0e0e0",
                borderRadius: "8px",
              }}
            >
              <Card
                style={{ zIndex: 1000 }}
                sx={{
                  backgroundColor: selectedIndexes.includes(index)
                    ? "rgba(255, 94, 67, 0.1)"
                    : "transparent",
                  transition: "background-color 0.3s ease, border 0.3s ease",
                }}
              >
                <CardHeader
                  title={
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <CustomCheckbox
                        checked={selectedIndexes.includes(index)}
                        onChange={(e) => e.stopPropagation()}
                        sx={{ color: "rgba(255, 94, 67, 0.8)" }}
                      />
                      <Box sx={{ marginLeft: "10px" }}>
                        <Box>{"กรมธรรม์เลขที่ : " + (policy?.policyNo || "-")}</Box>
                        <Box sx={{ marginTop: "4px" }}>
                          {"ชื่อแบบประกัน : " + (policy?.baseName || "-")}
                        </Box>
                      </Box>
                    </Box>
                  }
                  sx={{
                    backgroundColor: "rgba(255, 94, 67, 0.3)",
                  }}
                  titleTypographyProps={{
                    sx: {
                      fontFamily: '"Prompt-Thin", sans-serif !important',
                      fontSize: "15px",
                      color: "black",
                      marginLeft: "15px",
                    },
                  }}
                />

                <CardContent>
                  <Typography>
                    <Grid container spacing={1}>
                      <Grid item xs={3} sm={3} md={1}>
                        <span className="font-size-label-pol">อีเมล :</span>
                      </Grid>
                      <Grid item xs={9} sm={9} md={11}>
                        <span className="font-size-label-pol">
                          {_.email || "-"}
                        </span>
                      </Grid>
                    </Grid>
                  </Typography>
                </CardContent>
              </Card>
            </Box>
          );
        })}
      </CardContent>
    </Card>
  );
};

export default ScrollableEmail;
